<template>
  <div>
    <div class="container">
      <div class="row">
        <div
          class="card-body"
          :style="{ padding: $mq !== 'sm' ? '3rem' : '1rem' }"
        >
          <div class="CTA" style="min-height:0">
            <h5
              class="mb-5 mt-5 mt-md-0"
              style="font-size: 30px; font-weight: normal;"
            >
              {{ sentence }}
              <br />
              <strong x-ms-format-detection="none">{{
                emailOrMobilePhone
              }}</strong>
            </h5>
          </div>
          <form
            class="mt-5 row"
            style="padding-left:15px;padding-right:15px;"
            data-vv-scope="editForm"
            @submit.prevent="validateForm('editForm', callbackForm)"
            v-cloak
          >
            <div class="form-group col-12">
              <div v-if="sentCode">
                <div class="pl-3 pr-3 form-group">
                  <input
                    id="confirmation"
                    type="text"
                    class="form-control $errors->has('confirmation') ? ' is-invalid' : '' }}"
                    name="confirmation"
                    required
                    :placeholder="$t('Codice di conferma')"
                    v-validate="'required'"
                    v-model="confirmationCode"
                  />
                  <label for="confirmation" class="h5">{{
                    $t("Codice di conferma")
                  }}</label>
                  <span
                    v-show="errors.has('confirmationForm.confirmation')"
                    class="invalid-feedback"
                    style="position: relative; bottom: 0px; padding-bottom: 10px;"
                  >
                    <strong>{{
                      errors.first("confirmationForm.confirmation")
                    }}</strong>
                  </span>
                </div>
              </div>
              <div v-else>
                <div class="pl-3 pr-3 form-group">
                  <input
                    name="number"
                    type="text"
                    class="form-control"
                    id="number"
                    :placeholder="
                      isEmail
                        ? $t('Modifica il tuo indirizzo email')
                        : $t('Inserisci il tuo numero')
                    "
                    v-model="toBeVerifiedAddress"
                    v-validate="'required|phoneOrEmail'"
                  />
                  <label for="mobile-number" class="h5">{{
                    isEmail
                      ? $t("Modifica il tuo indirizzo email")
                      : $t("Inserisci il tuo numero")
                  }}</label>
                  <span
                    v-show="errors.has('confirmationForm.number')"
                    class="invalid-feedback"
                    style="position: relative; bottom: 0px; padding-bottom: 10px;"
                  >
                    <strong>{{
                      errors.first("confirmationForm.number")
                    }}</strong>
                  </span>
                </div>
              </div>
            </div>
            <div
              class="row"
              style="width:100%"
              :style="{
                'margin-top': $mq !== 'sm' && $mq !== 'md' ? '89px' : '0'
              }"
            >
              <div
                v-if="sentCode"
                class="col-12 col-lg-6 text-center text-lg-left"
                style="line-height:48px"
              >
                <small>{{ $t("Non hai ricevuto il codice?") }}</small>
                <a
                  class="c-form-actions__link btn-not-spinner"
                  href="#"
                  @click="resendVerifyCode"
                  >{{ $t("Resend") }}</a
                >
              </div>

              <div
                v-if="sentCode"
                class="form-group col-12 col-lg-6 text-center text-lg-right"
                style="padding-top: 0"
              >
                <button class="btn btn-primary btn-lg">
                  {{ $t("Conferma") }}
                </button>
              </div>
              <div v-else class="form-group col-12 col-lg-6">
                <button class="btn btn-primary btn-lg">
                  {{ $t("Invia") }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "edit-address",
  props: {
    address: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      sentCode: false,
      toBeVerifiedAddress: "",
      confirmationCode: null
    };
  },
  created() {},
  computed: {
    isEmail() {
      return _.has(this.address, "email");
    },
    sentence() {
      if (this.isEmail) {
        return this.$t("Modifica il tuo indirizzo email");
      }

      return this.$t("Modifica il tuo numero di cellulare");
    },
    emailOrMobilePhone() {
      if (this.isEmail) {
        return this.address.email;
      }

      return this.address.number;
    },
    insertSentence() {
      if (this.isEmail) {
      }
    }
  },
  methods: {
    callbackForm() {
      if (this.sentCode) {
        return this.verifyCode();
      }

      return this.sendVerifyCode();
    },
    async sendVerifyCode() {
      this.$store.commit("showSpinner");
      if (this.isEmail) {
        try {
          let response = await this.$http.post(
            "api/v1/campaigns/" + this.$store.state.campaign.id + "/email",
            {
              email: this.toBeVerifiedAddress
            }
          );
          this.sentCode = true;
        } catch {
          this.$store.commit("pushMessage", {
            type: "error",
            title: "Error",
            text: "An error occurred"
          });
        }
      } else {
        try {
          let response = await this.$http.post(
            "api/v1/campaigns/" + this.$store.state.campaign.id + "/mobile",
            {
              mobile: this.toBeVerifiedAddress
            }
          );
          this.sentCode = true;
        } catch {
          this.$store.commit("pushMessage", {
            type: "error",
            title: "Error",
            text: "An error occurred"
          });
        }
      }
      this.$store.commit("hideSpinner");
    },
    async verifyCode() {
      this.$store.commit("showSpinner");
      if (this.isEmail) {
        try {
          let response = await this.$http.post(
            "api/v1/campaigns/" +
              this.$store.state.campaign.id +
              "/email/verifyEdit",
            {
              email: this.toBeVerifiedAddress,
              verify_code: this.confirmationCode,
              old_email_id: this.address.email
            }
          );
          this.$router.push("/settings/profile");
        } catch (e) {
          let errorStatus = _.get(e, "response.status");
          if (errorStatus === 404) {
            this.$store.commit("pushMessage", {
              type: "error",
              title: "Error",
              text: "Invalid code"
            });
          } else {
            this.$store.commit("pushMessage", {
              type: "error",
              title: "Error",
              text: "An error occurred"
            });
          }
        }
      } else {
        try {
          let response = await this.$http.post(
            "api/v1/campaigns/" +
              this.$store.state.campaign.id +
              "/mobile/verifyEdit",
            {
              mobile: this.toBeVerifiedAddress,
              verify_code: this.confirmationCode,
              old_mobile_id: this.address.id
            }
          );
          this.$router.push("/settings/profile");
        } catch {
          let errorStatus = _.get(e, "response.status");
          if (errorStatus === 404) {
            this.$store.commit("pushMessage", {
              type: "error",
              title: "Error",
              text: "Invalid code"
            });
          } else {
            this.$store.commit("pushMessage", {
              type: "error",
              title: "Error",
              text: "An error occurred"
            });
          }
        }
      }
      this.$store.commit("hideSpinner");
    },
    async resendVerifyCode() {
      this.$store.commit("showSpinner");
      if (this.isEmail) {
        try {
          let response = await this.$http.post(
            "api/v1/campaigns/" +
              this.$store.state.campaign.id +
              "/email/resendVerify",
            {
              email: this.toBeVerifiedAddress
            }
          );
        } catch {
          this.$store.commit("pushMessage", {
            type: "error",
            title: "Error",
            text: "An error occurred"
          });
        }
      } else {
        try {
          let response = await this.$http.post(
            "api/v1/campaigns/" +
              this.$store.state.campaign.id +
              "/mobile/resendVerify",
            {
              mobile: this.toBeVerifiedAddress
            }
          );
        } catch {
          this.$store.commit("pushMessage", {
            type: "error",
            title: "Error",
            text: "An error occurred"
          });
        }
      }
      this.sentCode = true;
      this.$store.commit("hideSpinner");
    }
  }
};
</script>
